/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { forwardRef } from 'react';

import { cssMap, jsx } from '@compiled/react';

import { fg } from '@atlaskit/platform-feature-flags';
import { token } from '@atlaskit/tokens';
import { TAB_GAP, TAB_GAP_OLD, TAB_HEIGHT } from '@atlassian/navigation-kit-common';

const TabWrapper = forwardRef<HTMLDivElement, React.PropsWithChildren<object>>(
	({ children }, ref) => (
		<div
			css={[styles.root, fg('blu-6305_tab_item_styling_in_horizontal_navigation') && styles.new]}
			ref={ref}
		>
			{children}
		</div>
	),
);

const styles = cssMap({
	root: {
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		gap: `${TAB_GAP_OLD}px`,
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		height: `${TAB_HEIGHT}px`,
		marginBottom: token('space.0'),
		marginLeft: token('space.negative.150'),
		marginRight: token('space.negative.150'),
		marginTop: token('space.0'),
		overflow: 'hidden',
		paddingBottom: token('space.0'),
		paddingLeft: token('space.150'),
		paddingRight: token('space.150'),
		paddingTop: token('space.0'),
	},
	new: {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
		gap: `${TAB_GAP}px`,
	},
});

export default TabWrapper;
